var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12ZM9.8 17.5L10.0042 14.4411L10.004 14.441L15.5685 9.41951C15.8127 9.20277 15.5151 9.09708 15.1909 9.29367L8.32364 13.6262L5.35734 12.7003C4.71675 12.5042 4.71215 12.064 5.50116 11.7475L17.0602 7.29044C17.5881 7.05076 18.0976 7.41724 17.8961 8.22526L15.9276 17.5016C15.7901 18.1607 15.3919 18.3184 14.84 18.0139L11.8414 15.7985L10.4 17.2C10.3955 17.2044 10.3909 17.2088 10.3864 17.2132C10.2252 17.3702 10.0919 17.5 9.8 17.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelegram);
export default __webpack_public_path__ + "static/media/icon-telegram.778e8244a7a2944d98906a4aa453eab8.svg";
export { ForwardRef as ReactComponent };